import React, { useEffect, useRef } from "react";
import timelineVideo from "../assets/timlinevideo.mp4";

function TimelineVideo() {
  const videoRef = useRef(null);
  useEffect(() => {
    const handleScroll = () => {
      const video = videoRef.current;
      const videoContainer = document.querySelector(
        ".timeline__video__container"
      );
      const videoLength = video.duration;
      const containerHeight = videoContainer.offsetHeight;
      const windowHeight = window.innerHeight;
      const scrollableDistance = containerHeight - windowHeight;
      const scrollPosition = window.scrollY;
      const videoTime = (scrollPosition / scrollableDistance) * videoLength;

      if (videoTime >= 0 && videoTime <= videoLength) {
        video.currentTime = videoTime;
      }

      if (videoContainer.getBoundingClientRect().bottom <= windowHeight) {
        video.style.position = "absolute";
        video.style.bottom = "0";
      } else {
        video.style.position = "fixed";
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className="timeline__video__container">
        <video
          ref={videoRef}
          muted
          className="timeline__video__container__video"
        >
          <source src={timelineVideo} type="video/mp4" />
        </video>
      </div>
    </>
  );
}

export default TimelineVideo;
